import { useTranslation } from "react-i18next";
import {
  Card,
  Col,
  Form,
  Row,
  Select,
  Space,
  Spin,
  Table,
  TableColumnProps,
} from "antd";
import { useEffect, useState } from "react";
import { ApiService, GetMyRequests, WorksPlanRequests } from "../../api";
import { Icon } from "@iconify/react";
import { PageHeader } from "../../components/PageHeader";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highcharts-gantt";
import HighchartMore from "highcharts/highcharts-more";
import draggable from "highcharts/modules/draggable-points";
import moment from "moment";

HighchartMore(Highcharts);
draggable(Highcharts);
interface RequestByStatusesProps {
  title: string;
  data: WorksPlanRequests[];
}

const RequestByStatuses = (props: RequestByStatusesProps) => {
  const day = 1000 * 60 * 60 * 24;

  const chartData = props.data.map((d, index) => ({
    start: moment(d.start_date).unix() * 1000,
    end: moment(d.end_date).unix() * 1000,
    name: d.title,
    id: d.id,
    y: index,
  }));

  const chartCategories = props.data.map((d) => d.number);

  console.log(chartData);

  const options = {
    chart: {
      spacingLeft: 1,
    },

    yAxis: {
      type: "category",
      categories: chartCategories,
    },

    xAxis: {
      currentDateIndicator: true,
      type: "datetime",
    },

    tooltip: {
      xDateFormat: "%d-%b-%y, %H:%M",
    },

    plotOptions: {
      series: {
        animation: false,
        dragDrop: {
          draggableX: true,
          draggableY: true,
          dragPrecisionX: day / 3, // Snap to eight hours
        },
        dataLabels: {
          enabled: true,
          format: "{point.name}",
          style: {
            cursor: "default",
            pointerEvents: "none",
          },
        },
        allowPointSelect: true,
        point: {
          events: {
            dragStart: () => {},
            drag: () => {},
            drop: () => {},
          },
        },
      },
    },
    series: [
      {
        name: "",
        data: chartData,
      },
    ],
  };

  return (
    <HighchartsReact
      constructorType={"ganttChart"}
      highcharts={Highcharts}
      options={options}
    />
  );
};

const WorksPlanPage = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<WorksPlanRequests[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const result = await ApiService.apiMainWorksPlanRequestsList();
      setData(result);
      setLoading(false);
    })();
  }, []);

  return (
    <div>
      <PageHeader title={t("Works Plan")} />
      <Spin spinning={loading}>
        <RequestByStatuses data={data} title={"asd"} />
      </Spin>
    </div>
  );
};

export default WorksPlanPage;
